import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/fieldPilot")({
  component: FieldPilotLayout,
});

function FieldPilotLayout() {
  return <Outlet />;
}
